import Head from "next/head";

type PageSeoProps = {
  title: string;
  description: string;
  locale?: string;
  keywords?: string;
};

const DEFAULT_KEYWORDS = {
  tr: "Stoneity, iş yönetimi, servis yönetimi, proje yönetimi, görev takibi, iş akışları, ITSM, müşteri hizmetleri",
  en: "Stoneity, work management, service management, project management, task tracking, workflows, ITSM, customer service",
};

export default function PageSeo({ title, description, locale, keywords }: PageSeoProps) {
  const normalizedLocale = locale === "tr" ? "tr" : "en";
  const defaultKeywords = DEFAULT_KEYWORDS[normalizedLocale];
  const mergedKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={mergedKeywords} />
    </Head>
  );
}
